<ng-container *ngIf="alternateDates && alternateDates.length > 0">
  <span class="date-selector-heading">Select from route date options below</span>
  <p-tabView (onChange)="onTabChange($event)" class="style2023 route-tabs">
    <p-tabPanel
      class="border-none"
      *ngFor="let date of alternateDates; let i = index"
      [header]="date.label"
    ></p-tabPanel>
  </p-tabView>
  <div class="full-width-border mb-3"></div>
</ng-container>
